import { MobilePositionEnteredNotificationComponent } from './../mobile-position-entered-notification/mobile-position-entered-notification.component';
import { ToastrService } from "ngx-toastr";
import { PositionEnteredNotificationParams, PositionEnteredNotificationComponent } from "./position-entered-notification.component";

export function ShowPositionEnteredNotification(toastr: ToastrService, params: PositionEnteredNotificationParams, mobileMode: string = 'desktop')
{
    const mobile = mobileMode != 'desktop';
    let config = Object.assign(toastr.toastrConfig, {});
    config.timeOut = 6000;
    config.closeButton = true;
    config.toastComponent = mobile? MobilePositionEnteredNotificationComponent :PositionEnteredNotificationComponent;
    return toastr.show(JSON.stringify(params), '', config);
}